import { PageHeader } from 'antd'
import React from 'react'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentEntry from '../../components/payment/PaymentEntry'

const Payment = () => {
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Payment"
          subTitle=""
          extra={[]}
        ></PageHeader>

        <PaymentEntry />
      </div>
    </div>
  )
}

export default Payment